import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import retargetEvents from 'react-shadow-dom-retarget-events';

import { Store } from 'redux';
import { initializeStore } from '@/redux/store';
import { TargetGroup } from '@/types/av-check';
import {
  initialState,
  reducer,
  actions,
} from '@/redux/av-check';

import CompendiumLoader from '@/components/CompendiumLoader';
import AvCheckWebComponent from '@/components/AvCheckWebComponent';

class HomeTariffAVCheck extends HTMLElement {
  store: Store;

  mountPoint: Element;

  serviceUrl: string;

  offerName: string;

  targetGroup: TargetGroup;

  contractDuration: number;

  shopContext: string;

  selectedPack?: string;

  selectedRouter?: string;

  hardwareOfferName?: string;

  manufacturerHeroOffer?: string;

  hardwareGroupNameHeroOffer?: string;

  byshColor?: string;

  byshStorageSize?: number | undefined;

  byshVertragsart?: string;

  byshRatenzahlung?: number | undefined;

  tariffVariationCode?: string;

  accessType?: string;


  static get observedAttributes() {
    return [
      'serviceurl',
      'offername',
      'targetgroup',
      'contractduration',
      'shopcontext',
      'selectedpack',
      'selectedrouter',
      'hardwareoffername',
      'manufacturerherooffer',
      'hardwaregroupnameherooffer',
      'byshcolor',
      'byshstoragesize',
      'byshvertragsart',
      'byshratenzahlung',
      'tariffVariationCode',
      'accessType',
    ];
  }

  connectedCallback() {
    this.store = initializeStore(initialState, reducer);

    this.mountPoint = document.createElement('span');
    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(this.mountPoint);
    retargetEvents(shadowRoot);

    try {
      this.serviceUrl = this.getRequiredAttribute('serviceUrl');
      this.offerName = this.getRequiredAttribute('offerName');
      this.shopContext = this.getRequiredAttribute('shopContext');
      this.targetGroup = (TargetGroup as any)[this.getRequiredAttribute('targetGroup').toUpperCase()];
      this.contractDuration = parseInt(this.getRequiredAttribute('contractDuration'), 10);
      this.selectedPack = this.getAttribute('selectedPack') || undefined;
      this.selectedRouter = this.getAttribute('selectedRouter') || undefined;
      this.hardwareOfferName = this.getAttribute('hardwareOfferName') || undefined;
      this.manufacturerHeroOffer = this.getAttribute('manufacturerHeroOffer') || undefined;
      this.hardwareGroupNameHeroOffer = this.getAttribute('hardwareGroupNameHeroOffer') || undefined;
      this.byshColor = this.getAttribute('byshColor') || undefined;
      this.byshVertragsart = this.getAttribute('byshVertragsart') || undefined;

      const byshStorageSize = this.getAttribute('byshStorageSize')|| undefined;
      const byshRatenzahlung = this.getAttribute('byshRatenzahlung')|| undefined;
      this.byshStorageSize = byshStorageSize ? parseInt(byshStorageSize,10) : undefined;
      this.byshRatenzahlung = byshRatenzahlung ? parseInt(byshRatenzahlung,10) : undefined;
      this.tariffVariationCode = this.getRequiredAttribute('tariffVariationCode');
      this.accessType = this.getRequiredAttribute('accessType');
      console.log("value of accessType : " + this.accessType);
      console.log("value of tariffVariationCode  : " +this.tariffVariationCode);
    } catch (error) {
      console.log(error.message);
    }

    this.render();
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    switch (name) {
      case 'serviceurl':
        this.serviceUrl = newValue;
        break;
      case 'offername':
        this.offerName = newValue;
        break;
      case 'shopcontext':
        this.shopContext = newValue;
        break;
      case 'targetgroup':
        this.targetGroup = (TargetGroup as any)[newValue.toUpperCase()];
        break;
      case 'contractduration':
        this.contractDuration = parseInt(newValue, 10);
        break;
      case 'selectedpack':
        this.selectedPack = newValue;
        break;
      case 'selectedrouter':
        this.selectedRouter = newValue;
        break;
      case 'hardwareoffername':
        this.hardwareOfferName = newValue;
        break;
      case 'manufacturerherooffer':
        this.manufacturerHeroOffer = newValue;
        break;
      case 'hardwaregroupnameherooffer':
        this.hardwareGroupNameHeroOffer = newValue;
        break;
      case 'byshcolor':
        this.byshColor = newValue;
        break;
      case 'byshstoragesize':
        this.byshStorageSize =  parseInt(newValue, 10);
        break;
      case 'byshvertragsart':
        this.byshVertragsart = newValue;
        break;
      case 'byshratenzahlung':
        this.byshRatenzahlung =  parseInt(newValue, 10);
        break;
      case 'tariffVariationCode':
        this.tariffVariationCode =  newValue;
        console.log("value of tariffVariationCode  : " +this.tariffVariationCode);
        break;
      case 'accessType':
        this.accessType =  newValue;
        console.log("value of accessType : " + this.accessType);
        break;
      default:
        break;
    }

    this.render();
  }

  getRequiredAttribute(qualifiedName: string) : string {
    const value = this.getAttribute(qualifiedName);
    if (!value) {
      throw new Error(`HomeTariffAVCheck: Missing parameters ${qualifiedName} = ${value}`);
    }

    return value;
  }

  checkOtherAddress() {
    if (this.store) {
      this.store.dispatch(actions.setResult(undefined));
      this.store.dispatch(actions.setResultError(false));
      this.store.dispatch(actions.setAddress({
        zipCode: '',
        city: '',
        street: '',
        houseNumber: '',
        corrected: false,
        buildingParts: []
      }));
      this.store.dispatch(actions.setHouseholdConfig({
        personInHousehold: 0,
        usageTypes: [],
      }))
    }
  }

  render() {
    if (this.store
        && this.mountPoint
        && this.serviceUrl
        && this.offerName
        && this.shopContext
        && this.targetGroup
        && this.contractDuration
    ) {
      ReactDOM.render(
          <Provider store={this.store}>
            <CompendiumLoader serviceUrl={this.serviceUrl} />
            <AvCheckWebComponent
                serviceUrl={this.serviceUrl}
                offerName={this.offerName}
                shopContext={this.shopContext}
                targetGroup={this.targetGroup}
                contractDuration={this.contractDuration}
                dispatchEvent={(event: CustomEvent) => {
                  console.log('HomeTariffAVCheck: dispatchEvent(addtocart)');
                  this.dispatchEvent(event);
                }}
                selectedPack={this.selectedPack}
                selectedRouter={this.selectedRouter}
                hardwareOfferName={this.hardwareOfferName}
                manufacturerHeroOffer={this.manufacturerHeroOffer}
                hardwareGroupNameHeroOffer={this.hardwareGroupNameHeroOffer}
                byshColor={this.byshColor}
                byshStorageSize={this.byshStorageSize}
                byshVertragsart={this.byshVertragsart}
                byshRatenzahlung={this.byshRatenzahlung}
                tariffVariationCode={this.tariffVariationCode}
                accessType={this.accessType}
            />
          </Provider>,
          this.mountPoint,
      );
    }
  }
}

if (window && window.customElements !== undefined) {
  window.customElements.define('home-tariff-av-check', HomeTariffAVCheck);
}
